module.exports = __webpack_public_path__ + "static/0005-31c77635eb3d7e7fbbf5ead5e2ae79f3.png";